<template>
  <div>
    <slot></slot>
    <div class="safe-area-element-bottom" :style="{ height: bottomHeight + 'px' }"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      bottomHeight: state => state.common.deviceInfo?.bottomHeight || 0
    })
  }
}
</script>
